import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";

export const PageLayout = ({ children }) => {
  return (
    <>
      <Header />
      <div>{children}</div>
      <Footer />
    </>
  );
};
